import React, { useState } from 'react';
import { useEffect } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'react-headless-accordion';
import { IoIosArrowBack } from 'react-icons/io';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { BsClock } from 'react-icons/bs'
const Treatment = ({ headline, info, time, index }) => {








    const [rotationStates, setRotationStates] = useState({});

    const toggleRotation = () => {
        setRotationStates((prevState) => ({
            ...prevState,
            [index]: !prevState[index],
        }));
    };

    const accordionTransitionDuration = 800; // Set the same duration as the accordion transition

    return (
        <div>

            <div data-aos="zoom-in" data-aos-easing="linear" data-aos-duration="500" data-aos-delay="0">
                <Accordion
                    className='hover:opacity-95 card bg-gradient-to-l from-mainBtn to-secondaryBtn text-textBtn border-4 border-borderBtn text-2xl font-semibold p-4 m-4 shadow-lg '
                    transition={{ duration: `${accordionTransitionDuration}ms`, timingFunction: 'cubic-bezier(0, 0, 0.2, 1)' }}
                >
                    <AccordionItem>
                        <AccordionHeader
                            className='items-center flex justify-between'
                            onClick={() => toggleRotation({ index })}
                        >
                            <IoIosArrowBack
                                className={rotationStates[index] ? 'rotate-90' : ''}
                                style={{ transition: `transform 0.4s ease-in-out` }}

                            />
                            <h3 className={`accordion-title text-right gold-text`} >{headline}</h3>
                        </AccordionHeader>

                        <AccordionBody className='card-normal text-accordionText'>
                            <div className='accordion-body'>
                                <div className='card shadow-xl mx-auto'>
                                    <div className='text-right p-4'>
                                        <p className='text-lg font-normal' dir='rtl'>{info}</p>
                                        <div dir='rtl' className=' flex text-right items-center'>
                                            <p className='text-lg font-bold mt-4 gold-text ' dir='rtl'>משך הטיפול: {time} דקות </p>
                                            <BsClock color='white' className='mx-2 mt-4' size={20} />

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
            </div>



        </div>

    );
};

export default Treatment;
